module.exports = __webpack_public_path__ + "img/Zoology.f92f5f43.svg";